import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, X, Gift } from 'lucide-react';

const KEY = 'pfs-update-banner-v1';

export default function UpdateBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = typeof window !== 'undefined' && window.localStorage.getItem(KEY);
    if (!dismissed) setVisible(true);
  }, []);

  const close = () => {
    setVisible(false);
    try { window.localStorage.setItem(KEY, '1'); } catch {}
  };

  return (
    <AnimatePresence initial={false}>
      {visible && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 0.9, 0.3, 1] }}
          className="relative z-[60] w-full bg-[hsl(var(--primary))] text-black"
          data-testid="update-banner"
        >
          <div className="container-x py-2 sm:py-2.5 flex items-center gap-2 sm:gap-3">
            <span className="hidden sm:inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-black/15 text-[10px] font-mono font-bold uppercase tracking-[0.15em] shrink-0">
              <Sparkles className="w-3 h-3" /> New
            </span>
            <span className="text-[12.5px] sm:text-[13.5px] font-semibold leading-snug flex-1 min-w-0">
              <Gift className="inline w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 align-[-2px]" />
              <span className="sm:hidden">v3.2 live · free <b>1 week of PRO</b> for everyone.</span>
              <span className="hidden sm:inline">Massive v3.2 update is live. <span className="opacity-85">Every user gets <b>1 week of PRO for free</b> — auto-applied on first login.</span></span>
            </span>
            <a
              href="#/pricing"
              className="hidden md:inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-black/15 hover:bg-black/25 text-xs font-bold transition-colors shrink-0"
              data-testid="update-banner-cta"
            >
              See what&apos;s new →
            </a>
            <button
              onClick={close}
              className="inline-flex items-center justify-center w-7 h-7 rounded-md hover:bg-black/15 transition-colors shrink-0"
              aria-label="Dismiss"
              data-testid="update-banner-close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
